import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Company } from '../../models/company.model';
import { DataFormModel } from '../../models/data-form-model.model';
import { FormGroup, Validators } from '@angular/forms';
import { UtilService } from '../../services/util.service';
import { CompanyService } from '../../services/company.service';

@Component({
  selector: 'app-company-page',
  templateUrl: './company-page.component.html',
  styleUrl: './company-page.component.scss'
})
export class CompanyPageComponent {

  @Input() company?: Company;

  public dataForm: DataFormModel = {
    image: {
      value: '',
      type: 'image',
      label: '',
      required: false,
      accept: 'image/*',
      validators: []
    },
    name: {
      value: '',
      type: 'text',
      label: 'Nombre de la compañia',
      requiredMessage: 'Por favor, ingrese el nombre de la compañia',
      required: true,
      validators: [Validators.required]
    },
    zipCode: {
      value: '',
      type: 'number',
      label: 'Código postal',
      requiredMessage: 'Por favor, ingrese el código postal',
      required: true,
      validators: [Validators.required]
    },
    neighborhood: {
      value: '',
      type: 'text',
      label: 'Colonia',
      requiredMessage: 'Por favor, ingrese la colonia',
      required: true,
      validators: [Validators.required]
    },
    city: {
      value: '',
      type: 'text',
      label: 'Ciudad',
      requiredMessage: 'Por favor, ingrese la ciudad',
      required: true,
      validators: [Validators.required]
    },
    state: {
      value: '',
      type: 'text',
      label: 'Estado',
      requiredMessage: 'Por favor, ingrese el estado',
      required: true,
      validators: [Validators.required]
    },
  }

  public submitted: boolean = false;

  public formCompany: FormGroup;

  public imageBase64: string | null = null;

  constructor(
    public activeModal: NgbActiveModal,
    public companyService: CompanyService,
    public utilService: UtilService,
  ) {
    this.formCompany = this.utilService.buildForm(this.dataForm);
  }

  get f() {
    return this.formCompany.controls;
  }

  ngOnInit(): void {
    if(this.company) {
      this.dataForm['name'].value = this.company.name;
      this.dataForm['zipCode'].value = this.company.zipCode;
      this.dataForm['neighborhood'].value = this.company.neighborhood;
      this.dataForm['city'].value = this.company.city;
      this.dataForm['state'].value = this.company.state;

      this.formCompany = this.utilService.buildForm(this.dataForm);
    }
  }

  isKeyOfCompany(key: string): key is keyof Company {
    return key in Company.prototype;
}

  /*
   ██████╗██████╗ ███████╗ █████╗ ████████╗███████╗
  ██╔════╝██╔══██╗██╔════╝██╔══██╗╚══██╔══╝██╔════╝
  ██║     ██████╔╝█████╗  ███████║   ██║   █████╗
  ██║     ██╔══██╗██╔══╝  ██╔══██║   ██║   ██╔══╝
  ╚██████╗██║  ██║███████╗██║  ██║   ██║   ███████╗
   ╚═════╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝   ╚═╝   ╚══════╝

  */
 /**
  * FUNCTION create
  */
  async create() {

    const flag = await this.companyService.create(
      this.formCompany.value
    );

    if(flag) {
      this.activeModal.close();
    }

  }

  /*
   ██████╗ ███╗   ██╗███████╗██╗██╗     ███████╗ ██████╗██╗  ██╗ █████╗ ███╗   ██╗ ██████╗ ███████╗
  ██╔═══██╗████╗  ██║██╔════╝██║██║     ██╔════╝██╔════╝██║  ██║██╔══██╗████╗  ██║██╔════╝ ██╔════╝
  ██║   ██║██╔██╗ ██║█████╗  ██║██║     █████╗  ██║     ███████║███████║██╔██╗ ██║██║  ███╗█████╗
  ██║   ██║██║╚██╗██║██╔══╝  ██║██║     ██╔══╝  ██║     ██╔══██║██╔══██║██║╚██╗██║██║   ██║██╔══╝
  ╚██████╔╝██║ ╚████║██║     ██║███████╗███████╗╚██████╗██║  ██║██║  ██║██║ ╚████║╚██████╔╝███████╗
   ╚═════╝ ╚═╝  ╚═══╝╚═╝     ╚═╝╚══════╝╚══════╝ ╚═════╝╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═══╝ ╚═════╝ ╚══════╝

  */
  /**
   * FUNCTION onFileChange
   * 
   * @param event 
   */
  onFileChange(event: any) {
    console.log(event);

    const file = event.target.files[0];

    const reader = new FileReader();
    reader.readAsDataURL(file); // toBase64
    reader.onload = () => {
      this.imageBase64 = reader.result as string; // base64 Image src
      console.log(this.imageBase64);
      
    };
    
  }

  /*
   ██████╗ ███╗   ██╗███████╗██╗   ██╗██████╗ ███╗   ███╗██╗████████╗
  ██╔═══██╗████╗  ██║██╔════╝██║   ██║██╔══██╗████╗ ████║██║╚══██╔══╝
  ██║   ██║██╔██╗ ██║███████╗██║   ██║██████╔╝██╔████╔██║██║   ██║
  ██║   ██║██║╚██╗██║╚════██║██║   ██║██╔══██╗██║╚██╔╝██║██║   ██║
  ╚██████╔╝██║ ╚████║███████║╚██████╔╝██████╔╝██║ ╚═╝ ██║██║   ██║
   ╚═════╝ ╚═╝  ╚═══╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝     ╚═╝╚═╝   ╚═╝

  */
 /**
  * FUNCTION onSubmit
  * 
  * @returns 
  */
  async onSubmit() {

    this.submitted = true;

    if(this.formCompany.invalid) {
      return;
    }

    this.formCompany.value.fileBase64 = this.imageBase64;
    this.formCompany.value.image = undefined;

    if(this.company) {
      await this.update();
    } else {
      await this.create();
    }
  }

  /*
  ██╗   ██╗██████╗ ██████╗  █████╗ ████████╗███████╗
  ██║   ██║██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██╔════╝
  ██║   ██║██████╔╝██║  ██║███████║   ██║   █████╗
  ██║   ██║██╔═══╝ ██║  ██║██╔══██║   ██║   ██╔══╝
  ╚██████╔╝██║     ██████╔╝██║  ██║   ██║   ███████╗
   ╚═════╝ ╚═╝     ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝

  */
  /**
  * FUNCTION update
  */
  async update() {

    const flag = await this.companyService.update(
      this.company!,
      this.formCompany.value
    );

    if(flag) {
      this.activeModal.close();
    }
    
  }

}
